function fillIn(
  min: number,
  max: number,
  aspectRatio: number,
  maxRatio: number,
) {
  const fill = max - min;
  const ratio = (maxRatio - aspectRatio) / (maxRatio - 1);
  return Math.round(min + ratio * fill);
}

export function getMaxPatronHeight(image: ImageVM, multiplier = 1) {
  const min = 20 * multiplier;
  const half = 40 * multiplier;
  const max = 70 * multiplier;

  const { width, height } = image;
  const aspectRatio = width / height;

  if (aspectRatio <= 1) {
    return max;
  } else if (aspectRatio >= 10) {
    return min;
  } else if (aspectRatio > 3.5) {
    return fillIn(min, half, aspectRatio, 10);
  } else {
    return fillIn(half, max, aspectRatio, 3.5);
  }
}
